import { gql } from '@ori/fetching';

import { conceptFragment } from './concept';

export const searchPreviewProduct = gql`
  ${conceptFragment}
  fragment SearchPreviewProduct on Product {
    productCode
    imageUrl
    conceptCode
    labels {
      ...ProductLabels
    }
    pdpUrl {
      relativeUrl
    }
    price {
      price {
        priceAfterImmediateDiscount
        currentPrice
      }
    }
    formattedPrice {
      price {
        basicCataloguePrice
        currentPrice
        priceAfterImmediateDiscount
      }
    }
    concept {
      ...BaseConcept
    }
  }
`;
